<template>
    <div class="summary-kpi-row">
        <div v-for="kpi in kpis" :key="kpi.key" class="summary-kpi-item">
            <div class="summary-kpi-item__value">{{ formatPercent(kpi.value) }}</div>
            <div class="summary-kpi-item__label">{{ kpi.label }}</div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    data: { type: Object, default: null },
    loading: { type: Boolean, default: false },
});

function formatPercent(value) {
    if (value == null) return '—';
    return new Intl.NumberFormat(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value) + '%';
}

const kpis = computed(() => [
    { key: 'l1Clear', label: 'Level 1 Clear', value: props.data?.l1ClearPct },
    { key: 'operatorClear', label: 'Operator Clear', value: props.data?.operatorClearPct },
    { key: 'l1Fault', label: 'L1 Fault %', value: props.data?.l1FaultPct },
    { key: 'phantom', label: 'Phantom Bags', value: props.data?.phantomPct },
    { key: 'mistrack', label: 'Mistracks', value: props.data?.mistrackPct },
]);
</script>

<style scoped>
.summary-kpi-row {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
}

.summary-kpi-item {
    flex: 1;
    min-width: 120px;
    background: var(--cui-card-bg, #fff);
    border: 1px solid var(--cui-card-border-color, #d8dbe0);
    border-radius: 0.375rem;
    padding: 1rem;
    text-align: center;
}

.summary-kpi-item__value {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--cui-body-color);
}

.summary-kpi-item__label {
    font-size: 0.75rem;
    text-transform: uppercase;
    color: var(--cui-text-muted);
    margin-top: 0.25rem;
}
</style>
